import type { TranslateDictionary } from './en.js';

export const It: TranslateDictionary = {
  'Drop a video file here to upload': 'Trascina qui un file video per caricarlo',
  or: 'o',
  'Upload complete!': 'Caricamento completato!',
  Retry: 'Riprova',
  'Pausing...': 'In pausa...',
  Resume: 'Riprendi',
  Pause: 'Pausa',
  'Upload a video': 'Carica un video',
  'No url or endpoint specified - cannot handle upload':
    'Nessun URL o endpoint specificato - impossibile gestire il caricamento',
};
